import { useQuery } from '@tanstack/react-query';
import api from '../../lib/api';

export type DashboardKPIs = {
  activeLoads: number;
  activeLoadsDelta: number;
  loadsThisMonth: number;
  loadsThisMonthDelta: number;
  customerCount: number;
  customerDelta: number;
  deliveredThisMonth: number;
  deliveredThisMonthDelta: number;
};

export type MonthlyPoint = {
  month: string;
  year: number;
  loads: number;
  delivered: number;
};

export type StatusBreakdownItem = {
  status: string;
  count: number;
};

export type TopProduct = {
  name: string;
  loads: number;
  units: number;
  pct: number;
};

export type TopCustomer = {
  name: string;
  loads: number;
  location: string;
};

export type CarrierItem = {
  name: string;
  loads: number;
};

export type RecentLoad = {
  id: string;
  loadNumber: string | null;
  customer: string;
  product: string;
  carrier: string;
  status: string;
  quantity: number;
  date: string;
};

export type DashboardData = {
  kpis: DashboardKPIs;
  monthlyLoads: MonthlyPoint[];
  statusBreakdown: StatusBreakdownItem[];
  topProducts: TopProduct[];
  topCustomers: TopCustomer[];
  carrierPerformance: CarrierItem[];
  heatmap: number[][];
  recentLoads: RecentLoad[];
};

export function useDashboard(enabled = true) {
  return useQuery<DashboardData>({
    queryKey: ['organization', 'analytics', 'dashboard'],
    queryFn: async () => {
      const resp = await api.get('/organization/analytics/dashboard');
      return resp.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
